const CustomizerTypeToStickerTypeMap: Record<CustomizerStickerT, StickerT> = {
  'sheath': 'sheath',
  'abutment-for-freehand-tad': 'abutment-for-freehand-tad',
  'additional-tad': 'additional-tad',
  'aligner-attachment': 'aligner-attachment',
  'bracket': 'bracket',
  'bracket-slot-cutout': 'bracket-slot-cutout',
  'button': 'button',
  'cutouts-for-easy-band-opening': 'cutouts-for-easy-band-opening',
  'debonding-attachment': 'debonding-attachment',
  'facemask-hook': 'facemask-hook',
  'hook': 'hook',
  'hook90': 'hook90',
  'screw8': 'screw8',
  'screw10': 'screw10',
  'screw12': 'screw12',
  'screw14': 'screw14',
  'ring': 'rings_and_pads',
  'pad': 'rings_and_pads',
};

export default function (stickers: CustomizerStickerI[]) {
  const stickerTypedIds: Partial<Record<StickerT, CustomizerStickerI[]>> = {};

  stickers.forEach((sticker) => {
    const stType = CustomizerTypeToStickerTypeMap[sticker.type];

    if (stickerTypedIds[stType]) {
      stickerTypedIds[stType]!.push(sticker);
    }
    else {
      stickerTypedIds[stType] = [sticker];
    }
  });

  return Object.values(stickerTypedIds).map((stickers) => {
    return stickers.map((st, index) => {
      const { name, price, pricePer, freeAmount, scale } = getStickerByType(st.type as CustomizerStickerT);

      const sticker = {
        id: st.id,
        type: st.type,
        name,
        scale,
        price,
        free: false,
        secondFree: false,
      };

      if (index < freeAmount) {
        sticker.free = true;
        sticker.secondFree = false;
        sticker.price = 0;
      }
      else if (pricePer > 1) {
        // work only for pricePer === 2
        const firstNonFree = (index - freeAmount) % pricePer === 0;
        sticker.free = false;
        sticker.secondFree = true;
        sticker.price = firstNonFree ? price : 0;
      }
      return sticker;
    });
  }).flatMap(x => x);
}
